import React from 'react'
import { faMapMarker } from '@fortawesome/free-solid-svg-icons'

import Button from '../Button/IconButton'
import Icon from '../Icon'

const MapButton = props => (
  <Button type='gray300' {...props}>
    <Icon icon={faMapMarker} fixedWidth />
  </Button>
)

export default MapButton
